import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GlobalService} from '../../service/global.service';
import {Usuario} from '../../model/usuario';
import {Subscription} from 'rxjs/Subscription';
import {environment} from '../../environments/environment';
import { ModalService } from '../../service/modal.service';

@Component({
    selector: 'menu',
    templateUrl: './menu.html',
    styleUrls: ['./menu.css']
})
export class MenuComponent implements OnInit {

    versao: string;
    usuario: Usuario;
    ambiente: string;
    _loginSubscription: Subscription;

    constructor(public globalService: GlobalService, private router: Router, public modalService: ModalService) {
        this.usuario = globalService.usuario;
        this._loginSubscription = globalService.usuarioChange.subscribe(
            (usuario) => {
                this.usuario = usuario;
            }
        );
    }

    ngOnInit() {
        this.globalService.setCookieUsuarioLogado();
        this.versao = environment.version;
        this.ambiente = this.globalService.configuracao.ambiente;
    }

    logoutRedirect() {
        this.globalService.logoutRedirect();
        this.router.navigateByUrl('/login');
    }

    logoutUsuario() {
        this.globalService.logoutUsuario();
        this.router.navigateByUrl('/login');
    }

    navegarParaHome() {
        this.router.navigate(['/catalogo']);
    }

    navegarPara(destino) {
        switch (destino) {
            case 'gerenciamentoArtefatos':
                this.router.navigate(['/artefato-home']);
                break;
            case 'produto-transmissao-arquivo':
                this.router.navigate(['/produto-transmissao-arquivo']);
                break;
            case 'instalacaoProduto':
                this.router.navigate(['/artefato-instalacao-produto']);
                break;
            case 'servico':
                this.router.navigate(['/artefato-servico']);
                break;
            case 'operacao':
                this.router.navigate(['/artefato-operacao']);
                break;
            case 'layoutArquivo':
                this.router.navigate(['/artefato-layout-arquivo']);
                break;
            case 'fluxoClienteInterno':
                this.router.navigate(['/fluxo-cliente-interno']);
                break;
            case 'fluxoClienteInternoCompleto':
                this.router.navigate(['/fluxo-cliente-interno-completo']);
                break;
            case 'fluxoClienteExterno':
                this.router.navigate(['/fluxo-cliente-externo']);
                break;
            case 'consultaFluxos':
                // this.router.navigate(['/consulta-fluxos']);
                this.router.navigate(['/pesquisa-fluxo']);
                break;
            case 'usuario':
                this.router.navigate(['/usuario']);
                break;
            case 'usuarioNovo':
                this.router.navigate(['/usuario-novo']);
                break;
            case 'arquivo-sia':
                this.router.navigate(['/arquivo-sia']);
                break;

        }
    }

    abrirAvaliacao() {
        this.modalService.abrirPaginaModal('avaliacao-modal', {}, {
          'tipo': "Avaliação",
        }, 'Deseja avaliar a sua experiência com este aplicativo?', '')
          .subscribe(avaliacao => {
            console.log("Enviado: " + JSON.stringify(avaliacao));
    
    
          });
    }

    ngOnDestroy() {
        this._loginSubscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/menu/menu.ts